import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoElizaWasHere = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m19.91 15.74-.2-.17-2.46-1.9 2.26-.22a3.17 3.17 0 0 0 2.21-1 1.83 1.83 0 0 0 .23-1.71s-.39-1.34-.87-1.24c-.476.088-.957.151-1.44.19l-.74.09-4.2.4.87-2.13 1-2.52a1.74 1.74 0 0 0 .08-1.34 1.73 1.73 0 0 0-1-.87l-.33-.13a1.52 1.52 0 0 0-2.2 1c-.36.93-.67 1.69-1 2.45-.33.76-.64 1.57-1 2.52L7.7 6.56a11.628 11.628 0 0 1-1-.83l-.61-.54a1.83 1.83 0 0 0-1.49-.52 1.59 1.59 0 0 0-1 .81l-.17.28a2.13 2.13 0 0 0-.4 1.12 1.47 1.47 0 0 0 .63 1.11l.54.48c.33.3.7.64 1.12 1l2.07 1.54-3.81.58a1.88 1.88 0 0 0-1.42.83 1.39 1.39 0 0 0 0 1.34l.13.3c.15.377.378.718.67 1a1.3 1.3 0 0 0 1.18.13l1.07-.16 3.9-.55a27.79 27.79 0 0 0-1 3.46 3.13 3.13 0 0 0 .2 2.44 2.08 2.08 0 0 0 1.41.9c.198.039.398.06.6.06.42 0 .87-.09.93-.36.387-2.04.932-4.045 1.63-6l3.3 2.44c.208.158.429.298.66.42l.37.2h.07l.17.09.27.1a2.2 2.2 0 0 0 1 .06 1.14 1.14 0 0 0 .79-.5.88.88 0 0 0 .14-.44v-.31a.239.239 0 0 1 0-.09v-.09c.19-.32.06-.72.28-.64.22.08.61-.05 0-.52l-.02.04Z"
    />
  </svg>
);
export default SvgLogoElizaWasHere;
